"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const babel_worker_1 = __importDefault(require("./babel-worker"));
class Sandbox {
    constructor(options) {
        this.userFiles = [];
        this.isRunning = false;
        this.project = fetchRpgKit2();
        this.onMessage = ((event) => {
            // Check origin
            if (Sandbox.iframeOrigins.indexOf(event.origin) < 0)
                return;
            const [port1] = event.ports || [];
            if (!port1)
                return;
            port1.addEventListener('message', this.onPortMessage, {
                passive: true
            });
            port1.start();
            // Close previours connection
            if (this.port) {
                this.port.removeEventListener('message', this.onPortMessage);
                this.port.close();
            }
            this.port = port1;
            this.isRunning = false;
            if (this.userFiles) {
                this.run(this.userFiles);
            }
        }).bind(this);
        this.onPortMessage = ((event) => __awaiter(this, void 0, void 0, function* () {
            switch (event.data.query) {
                case 'resolve':
                    return this.reply(event, yield this.resolve(event.data.value));
                case 'fetchText':
                    return this.reply(event, yield this.fetchText(event.data.value));
                case 'fetchDataURL':
                    return this.reply(event, yield this.fetchDataURL(event.data.value));
                default:
                    console.warn(event);
                    break;
            }
        })).bind(this);
        // connect to iframe
        window.addEventListener('message', this.onMessage, { passive: true });
        this.userFiles = options && options.userFiles;
    }
    get entryPoints() {
        return this.project.then(files => {
            return [files.find(file => file.name === 'main.js')].concat(this.userFiles || []);
        });
    }
    run(userFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userFiles) {
                this.userFiles = userFiles;
            }
            if (this.isRunning) {
                this.reload();
            }
            else if (this.port) {
                this.isRunning = true;
                this.port.postMessage({
                    query: 'entry',
                    value: yield this.entryPoints
                });
            }
        });
    }
    update(userFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            this.userFiles = userFiles;
        });
    }
    /**
     * TODO: ??
     */
    reload() {
        const iframe = document.querySelector('iframe');
        iframe && (iframe.src = iframe.src);
        this.isRunning = false;
    }
    dispose() {
        // stop connecting to iframe
        window.removeEventListener('message', this.onMessage);
        this.isRunning = false;
        this.port = undefined;
    }
    reply(event, payload) {
        this.port &&
            this.port.postMessage(Object.assign({ id: event.data.id }, payload));
    }
    resolve(name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (name.startsWith('https')) {
                const response = yield fetch(name);
                return { value: yield response.text() };
            }
            let project = yield this.project;
            const file = project.find(file => file.name === name || file.name === name + '.js');
            return file ? { value: file.code } : { error: `${name} not found` };
        });
    }
    fetchText(name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (name.startsWith('https')) {
                const response = yield fetch(name);
                return { value: yield response.text() };
            }
            let project = yield this.project;
            const file = project.find(file => file.name === name || file.name === name + '.js');
            console.log(name, file);
            return file ? { value: file.text } : { error: `${name} not found` };
        });
    }
    fetchDataURL(name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (name.startsWith('https')) {
                const response = yield fetch(name);
                const blob = yield response.blob();
                return new Promise(resolve => {
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        resolve({ value: fileReader.result });
                    };
                    fileReader.readAsDataURL(blob);
                });
            }
            let project = yield this.project;
            const file = project.find(file => file.name === name || file.name === name + '.js');
            return file && file.text
                ? { value: `data:,${encodeURIComponent(file.text)}` }
                : { error: `${name} not found` };
        });
    }
}
exports.Sandbox = Sandbox;
Sandbox.iframeOrigins = [
    'https://hackforplay-sandbox.firebaseapp.com'
    // 'http://localhost:1234'
];
function fetchRpgKit2() {
    return __awaiter(this, void 0, void 0, function* () {
        const infoRes = yield fetch('https://www.hackforplay.xyz/api/officials/make-rpg-2');
        const info = yield infoRes.json();
        const workJsonUrl = info.workJsonUrl;
        if (typeof workJsonUrl !== 'string') {
            console.error(info);
            throw new Error('Invalid info from /officials/make-rpg-2');
        }
        const projectRes = yield fetch(workJsonUrl);
        const project = yield projectRes.json();
        if (!Array.isArray(project)) {
            console.error(project);
            throw new Error(`Invalid project from ${project}`);
        }
        const files = project.map((file) => __awaiter(this, void 0, void 0, function* () {
            return Object.assign(Object.assign({ text: file.composed }, file), { code: yield babel_worker_1.default(file) });
        }));
        const result = yield Promise.all(files);
        for (const file of result) {
            if (file.name === 'game.js') {
                // game.js に書かれた「ゲームがつくられたとき」を物理的に消さない限り、定義を上書きできない
                file.code = file.code
                    .split('\n')
                    .slice(0, 9)
                    .join('\n');
            }
        }
        return result;
    });
}
